window.jQuery = require('jquery');
require('./../../target/node_modules/vecna-javascript/jquery.print');
var _ = require('underscore');
var moment = require('moment');

var i18nUtils = require('./../utils/i18nUtils');
var launcherAppInterface = require('./../launcherApplicationInterface');
var logoutUtils = require('./../authentication/logoutUtils');
var AppointmentDisplayStatusEnum = require('./AppointmentDisplayStatusEnum');
var appointmentExtService = require('./../urls').appointmentExtService;
var userService = require('./../user/userService');

var AccordionWidget = require('./../widget/accordion/AccordionWidget');
var ReceiptSummaryAccordionTriggerView = require('./../receipt/ReceiptSummaryAccordionTriggerView');
var ReceiptSummaryListWidget = require('./../receipt/ReceiptSummaryListWidget');
var AppointmentInsuranceListWidget = require('./../appointment-insurance/AppointmentInsuranceListWidget');
var AppointmentQuestionnaireListView = require('./../appointment-questionnaire/AppointmentQuestionnaireListView');
var DocumentListWidget = require('./../document/DocumentListWidget');

var AsideBehavior = require('./../aside/AsideBehavior');
var AppointmentTypeParentBehavior = require('./../behaviors/AppointmentTypeParentBehavior');
var AppointmentDataBehavior = require('./AppointmentDataBehavior');
var AppointmentTypeDataBehavior = require('./../appointment-type/AppointmentTypeDataBehavior');
var LocationDataBehavior = require('./../location/LocationDataBehavior');
var PortalPerspectiveLayoutBehavior = require('./../PortalPerspectiveLayoutBehavior');
var SecureMessageDataBehavior = require('./../secure-message/SecureMessageDataBehavior');
var UseModalBehavior = require('./../widget/modal/UseModalBehavior');
var DemographicsDataBehavior = require('./../demographics/DemographicsDataBehavior');

var LayoutPerspective = require('./../layout/LayoutPerspective');
var ModalDialogWidget = require('./../widget/modal/ModalDialogWidget');
var EstimatedBillWidget = require('./../estimate/EstimatedBillWidget');

var appointmentDetailsTemplate = require('./appointmentDetailsTemplate.hbs');

var onsiteConfigModel = require('./../onsite-config/onsiteConfigModel');
var financialFeatureConfigModel = require('./../financial/financialFeatureConfigModel');
var insuranceFeatureConfigModel = require('./../appointment-insurance/insuranceFeatureConfigModel');
var questionnaireFeatureConfigModel = require('./../questionnaire/questionnaireFeatureConfigModel');
var formFeatureConfigModel = require('./../form/formFeatureConfigModel');
var specificAppointmentFeatureConfigCollection = require('./specificAppointmentFeatureConfigCollection');
var MultiAppointmentSelectionBehavior = require('./MultiAppointmentSelectionBehavior');

var wizardUtils = require('./../wizard/wizardUtils');
var appointmentConfigurationModel = require('./../appointment-config/appointmentConfigurationModel');

var EXTERNAL_BTN_LABEL = 'appointment.prereg.confirmation.external.btn.label';
var EXTERNAL_BTN_URL = 'appointment.prereg.confirmation.external.btn.url';
var EXTERNAL_BTN_DESCRIPTION = 'appointment.prereg.confirmation.external.btn.description';
var EXTERNAL_BTN_PATIENT_IDENTIFIER_SOURCE_NAME = 'appointment.prereg.confirmation.external.btn.patientIdentifierSourceName';

/**
 * Perspective to display the Appointment Details page
 *
 * @class AppointmentDetailsPerspective
 * @param options {Object} Options to configure this perspective.
 *   @param [options.patientVecnaId] {String} the vecna id of the current patient
 *   @param [options.appointmentExternalId] {String} the external id of the current appointment
 */
module.exports = LayoutPerspective.extend({
  template: appointmentDetailsTemplate,
  moduleNamespace: 'appointmentDetailsPerspective',

  behaviors: {
    multiAppointmentSelectionBehavior: MultiAppointmentSelectionBehavior,
    portalPerspectiveLayoutBehavior: PortalPerspectiveLayoutBehavior,
    asideBehavior: {
      behavior: AsideBehavior,
      asideHeaderMessageKey: 'aside.information.header',
      asideContentMessageKey: 'appointmentDetail.aside'
    },
    useModalBehavior: UseModalBehavior,
    appointmentTypeParentBehavior: AppointmentTypeParentBehavior,
    appointment: {
      behavior: AppointmentDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      id: {property: '_appointmentExternalId'},
      alwaysFetch: true
    },
    appointmentMessages: {
      behavior: SecureMessageDataBehavior,
      alwaysFetch: true,
      ids: function(cache) {
        var criteria = {
          isPatient: true,
          appointmentCriteria: {
            externalAppointmentCriteria: {
              externalIds: [this.view._appointmentExternalId]
            }
          }
        };
        return cache.fetchIdsByCriteria(criteria);
      }
    },
    appointmentType: {
      behavior: AppointmentTypeDataBehavior,
      returnSingleResult: true,
      ids: {property: 'behaviors.appointment.data:externalAppointment.type'}
    },
    parentAppointmentType: {
      behavior: AppointmentTypeDataBehavior,
      returnSingleResult: true,
      ids: {property: 'behaviors.appointmentType.data:parentExternalId'}
    },
    grandparentAppointmentType: {
      behavior: AppointmentTypeDataBehavior,
      returnSingleResult: true,
      ids: {property: 'behaviors.parentAppointmentType.data:parentExternalId'}
    },
    location: {
      behavior: LocationDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      ids: {property: 'behaviors.appointment.data:externalAppointment.locationCode'}
    },
    demographics: {
      behavior: DemographicsDataBehavior,
      returnSingleResult: true,
      ids: { property: '_patientVecnaId' }
    }
  },

  prepareFields: {
    removeAppointmentTimeDisplay: function() {
      if (appointmentConfigurationModel.isLoading() || !appointmentConfigurationModel.hasLoadedOnce()) {
        return false;
      }
      return appointmentConfigurationModel.get('removeAppointmentTimeDisplay');
    }
  },

  events: _.extend({}, LayoutPerspective.prototype.events, {
    'click [data-print]' : '_print',
    'click [data-ereg-signout]' : '_logout',
    'click [data-back]': '_back'
  }),

  /**
   * @method setRouteContext set any context var passed in by the router
   * @param queryObject {Object} hash of parameter names to values from the route.
   *   @param [queryObject.receiptPage=1] {String} the page of the receipt list view to display.
   *   @param [queryObject.isFromMultiAppts] {boolean} whether the previous page is from multi appts confirmation page
   */
  setRouteContext: function(queryObject) {
    if (this._receiptAccordionContentView) {
      this._receiptAccordionContentView.setPage(queryObject.receiptPage);
    }
    if (queryObject.isFromMultiAppts) {
      this.set('isFromMultiAppts', true);
    } else {
      this.set('isFromMultiAppts', false);
    }
  },

  /**
   * @method initialize
   * @override
   * @param options {Object} Options to configure this perspective.
   *   @param [options.patientVecnaId] {String} the vecna id of the current patient
   *   @param [options.appointmentExternalId] {String} the external id of the current appointment
   */
  initialize: function(options) {
    LayoutPerspective.prototype.initialize.apply(this);
    _.bindAll(this, 'render', '_setAppointmentConfigsToView');

    this._patientVecnaId = options.patientVecnaId;
    this._appointmentExternalId = options.appointmentExternalId || this._appointmentExternalId;

    this._setupEstimatedBillAccordion();
    this._setupInsuranceAccordion();
    this._setupReceiptAccordion();
    this._setupQuestionnaireAccordion();
    this._setupDocumentsAccordion();

    var appointmentDataBehavior = this.getBehavior('appointment');
    this.listenTo(appointmentDataBehavior, 'fetched', function() {
      this.set('isAppointmentConfigLoaded', false);
      specificAppointmentFeatureConfigCollection
        .fetchByCriteria(appointmentDataBehavior.data.getModel())
        .done(this._setAppointmentConfigsToView);
    });

    this.listenTo(this.getBehavior('appointmentMessages'), 'fetched', this._markAppointmentAsRead);

    this.listenTo(this.viewState, 'change:preventBarcode change:isAppointmentConfigLoaded change:patientIdentifier', this.render);
    onsiteConfigModel.loadOnce();
    this.listenTo(onsiteConfigModel, 'change:barcodeEnabled', this.render);
    financialFeatureConfigModel.loadOnce();
    insuranceFeatureConfigModel.loadOnce();
    questionnaireFeatureConfigModel.loadOnce();
    formFeatureConfigModel.loadOnce();
    this.listenTo(appointmentConfigurationModel, 'change:removeAppointmentTimeDisplay change:mapDefaultEndAddress change:mapDefaultLatitude change:mapDefaultLongitude', this.render);
    appointmentConfigurationModel.loadOnce();
  },

  /**
   * Setup the accordion for showing estimated bills.
   * @method _setupEstimatedBillAccordion
   * @private
   */
  _setupEstimatedBillAccordion: function() {
    this.listenTo(this.getBehavior('appointmentType'), 'change:parent', this._initializeEstimatedBillWidget);
    this.listenTo(this.getBehavior('parentAppointmentType'), 'change:parent', this._initializeEstimatedBillWidget);
    this._estimatedBillWidget = null;
  },

  /**
   * Setup the accordion for showing insurances.
   * @method _setupInsuranceAccordion
   * @private
   */
  _setupInsuranceAccordion: function() {
    this._insuranceAccordionContentView = new AppointmentInsuranceListWidget({
      patientVecnaId: this._patientVecnaId,
      appointmentExternalId: this._appointmentExternalId,
      viewOnly: true
    });
    this.listenTo(this._insuranceAccordionContentView, 'insurances-updated', this.render);
    this._insuranceAccordionView = new AccordionWidget({
      accordionId: 'appointment-details-insurance-accordion',
      contentNoPadding: true,
      accordionTriggerMessageKey: 'appointment.detail.insurances.slideToggleHeader.title',
      accordionContentViewInstance: this._insuranceAccordionContentView
    });
    this.registerTrackedView(this._insuranceAccordionView);
  },

  /**
   * Setup the accordion for showing the receipt.
   * @method _setupReceiptAccordion
   * @private
   */
  _setupReceiptAccordion: function() {
    this._receiptAccordionContentView = new ReceiptSummaryListWidget({
      patientVecnaId: this._patientVecnaId,
      appointmentExternalId: this._appointmentExternalId
    });
    this.listenTo(this._receiptAccordionContentView, 'receipts-updated', this.render);
    this._receiptAccordionView = new AccordionWidget({
      accordionId: 'appointment-details-receipt-accordion',
      showAccordionContent: true,
      contentNoPadding: true,
      accordionTriggerViewInstance: new ReceiptSummaryAccordionTriggerView({
        receiptSummaryListWidget: this._receiptAccordionContentView
      }),
      accordionContentViewInstance: this._receiptAccordionContentView
    });
    this.registerTrackedView(this._receiptAccordionView);
  },

  /**
   * Setup the accordion for showing the questionnaire details.
   * @method _setupQuestionnaireAccordion
   * @private
   */
  _setupQuestionnaireAccordion: function() {
    this._questionnaireAccordionContentView = new AppointmentQuestionnaireListView({
      patientVecnaId: this._patientVecnaId,
      appointmentExternalId: this._appointmentExternalId
    });
    this.listenTo(this._questionnaireAccordionContentView, 'questionnaires-updated', this.render);
    this._questionnaireAccordionView = new AccordionWidget({
      accordionId: 'appointment-details-questionnaire-accordion',
      accordionTriggerMessageKey: 'appointment.detail.questionnaire.slideToggleHeader.title',
      accordionContentViewInstance: this._questionnaireAccordionContentView
    });
    this.registerTrackedView(this._questionnaireAccordionView);
  },

  /**
   * Setup the accordion for showing the document and form details.
   * @method _setupDocumentsAccordion
   * @private
   */
  _setupDocumentsAccordion: function() {
    this._documentAccordionContentView = new DocumentListWidget({
      appointmentExternalId: this._appointmentExternalId
    });
    this.listenTo(this._documentAccordionContentView, 'documents-updated', this.render);
    this._documentAccordionView = new AccordionWidget({
      accordionId: 'appointment-details-document-accordion',
      accordionTriggerMessageKey: 'appointment.detail.signedDocument.slideToggleHeader.title',
      accordionContentViewInstance: this._documentAccordionContentView
    });
    this.registerTrackedView(this._documentAccordionView);
  },

  /**
   * @method _initializeEstimatedBillWidget
   * @private
   * Initialize the estimated bill widget if appointment type allows estimated pay
   */
  _initializeEstimatedBillWidget: function() {
    var appointmentType = this.getBehavior('appointmentType').data.getModel();
    if (this._estimatedBillWidget == null && appointmentType.getEffectiveAllowEstimatedPay()) {
      this._estimatedBillWidget = new EstimatedBillWidget({
        isOnAppointmentDetails: true,
        appointmentExternalId: this._appointmentExternalId
      });
      this.registerTrackedView(this._estimatedBillWidget);
      this.listenTo(this._estimatedBillWidget, 'estimate-updated', this.render);
      this.render();
    }
  },

  _attached: function() {
    this.listenTo(financialFeatureConfigModel, 'load-complete', this.render);
    this.listenTo(insuranceFeatureConfigModel, 'load-complete', this.render);
    this.listenTo(questionnaireFeatureConfigModel, 'load-complete', this.render);
    this.listenTo(formFeatureConfigModel, 'load-complete', this.render);
    if (this._estimatedBillWidget) {
      this.listenTo(this._estimatedBillWidget, 'change:totalCharges', this.render);
    }
  },

  _detached: function() {
    this.stopListening(financialFeatureConfigModel, 'load-complete', this.render);
    this.stopListening(insuranceFeatureConfigModel, 'load-complete', this.render);
    this.stopListening(questionnaireFeatureConfigModel, 'load-complete', this.render);
    this.stopListening(formFeatureConfigModel, 'load-complete', this.render);
    this.stopListening(this._estimatedBillWidget, 'change:totalCharges', this.render);
  },

  /**
   * @method refreshAppointmentData
   *
   * Re-fetches appointment data, so page can stay up-to-date.
   * Meant to be called by the router, when restoring a cached version of this perspective.
   */
  refreshAppointmentData: function() {
    this.getBehavior('appointment').fetch();
    this.getBehavior('appointmentMessages').fetch();
  },

  /**
   * @method prepare
   * @override
   */
  prepare: function() {
    var templateContext = LayoutPerspective.prototype.prepare.apply(this);
    var externalAppointment = this.getBehavior('appointment').data.get('externalAppointment');
    if (externalAppointment) {
      templateContext.renderSurveyResponseList = externalAppointment.preregistered || externalAppointment.checkedIn;
      var hasSurveyResponsesToDisplay = !_.isEmpty(externalAppointment.surveyResponses);
      if (hasSurveyResponsesToDisplay) {
        templateContext.questionnaireNames = _.keys(externalAppointment.surveyResponses);
      }
    }

    templateContext.barcodeCheckInEnabled = onsiteConfigModel && onsiteConfigModel.get('barcodeEnabled');
    var barcodeAllowedForAppointment = this.get('preventBarcode') === false;
    if (templateContext.barcodeCheckInEnabled && barcodeAllowedForAppointment) {
      templateContext.barcodeUrl = appointmentExtService + '/' + this._appointmentExternalId + '/barcode?orientation=90';
    }
    templateContext.isAtHospital = launcherAppInterface.isAtHospital();
    // Force the use of the single appt url by not setting the regDate.
    templateContext.preRegAppointmentUrl = wizardUtils.generateRootRegUrl({
      patientVecnaId: this._patientVecnaId,
      appointmentExternalId: this._appointmentExternalId
    });
    templateContext.patientVecnaId = this._patientVecnaId;

    var appointmentTypeModel = this.getBehavior('appointmentType').data.getModel();
    if (appointmentTypeModel) {
      templateContext.instructions = appointmentTypeModel.getEffectiveInstructions();
      templateContext.appointmentTimeReplacement = appointmentTypeModel.getEffectiveAppointmentTimeReplacement();
      templateContext.displayName = appointmentTypeModel.get('displayName');
    } else {
      templateContext.displayName = this.getBehavior('appointment').data.get('externalAppointment.type');
    }
    templateContext.appointmentStatus = this._getAppointmentStatus();

    var hasExternalBtnLabel = i18nUtils.hasPropertyValue(EXTERNAL_BTN_LABEL);
    var hasExternalBtnUrl = i18nUtils.containsExternalLink(EXTERNAL_BTN_URL);
    templateContext.showExternalBtn = hasExternalBtnLabel && hasExternalBtnUrl && !launcherAppInterface.isAtHospital();
    templateContext.showExternalBtnDescription = templateContext.showExternalBtn && i18nUtils.hasPropertyValue(EXTERNAL_BTN_DESCRIPTION);

    templateContext.externalBtnLabel = EXTERNAL_BTN_LABEL;
    templateContext.externalBtnUrl = i18nUtils.getI18nPropertyValue(EXTERNAL_BTN_URL);
    templateContext.externalBtnDescription = EXTERNAL_BTN_DESCRIPTION;
    templateContext.appointmentExternalId = this._appointmentExternalId;

    var patientIdentifierSourceName = i18nUtils.getI18nPropertyValue(EXTERNAL_BTN_PATIENT_IDENTIFIER_SOURCE_NAME);
    var demographicsModel = this.getBehavior('demographics').data.getModel();
    var patientIdentifiers = demographicsModel && demographicsModel.get('identifiers');
    var patientIdentifier = _.findWhere(patientIdentifiers, {
      sourceName: patientIdentifierSourceName
    });
    if (patientIdentifier) {
      templateContext.patientIdentifier = patientIdentifier.identifier;
    }

    templateContext.appointmentConfigurationModel = appointmentConfigurationModel.toJSON();
    var destination = this._getEndAddress() || this._getDefaultDestination();
    templateContext.destination = encodeURIComponent(destination);
    templateContext.hasAppointmentLocation = this._hasAppointmentLocation();
    return templateContext;
  },

  /**
   * @method attachTrackedViews
   * @override
   */
  attachTrackedViews: function() {
    if (financialFeatureConfigModel.isPaymentEnabled(financialFeatureConfigModel.CONFIG_LEVEL.NORMAL)
        && this._receiptAccordionContentView.hasReceipts()) {
      this.attachView('appointment-receipts', this._receiptAccordionView);
    }
    if (insuranceFeatureConfigModel.isEnabledNormalLevel()
        && this._insuranceAccordionContentView.hasInsurances()) {
      this.attachView('appointment-insurances', this._insuranceAccordionView);
    }
    if (financialFeatureConfigModel.isEstimatedCostEnabled(financialFeatureConfigModel.CONFIG_LEVEL.NORMAL)
        && this._estimatedBillWidget && this._estimatedBillWidget.isLoadingOrHasEstimate()) {
      this.attachView('appointment-bills', this._estimatedBillWidget);
    }
    if (questionnaireFeatureConfigModel.isEnabledNormalLevel()
        && this._questionnaireAccordionContentView.hasQuestionnaires()) {
      this.attachView('appointment-questionnaires', this._questionnaireAccordionView);
    }
    if (formFeatureConfigModel.isEnabledNormalLevel()
        && this._documentAccordionContentView.hasDocuments()) {
      this.attachView('appointment-documents', this._documentAccordionView);
    }
  },

  /**
   * Gets what the appointment status is
   * @method _getAppointmentStatus
   * @private
   */
  _getAppointmentStatus: function() {
    var appointment = this.getBehavior('appointment').data.get('externalAppointment');
    var appointmentType = this.getBehavior('appointmentType').data.getModel();
    if (appointment == null) {
      return AppointmentDisplayStatusEnum.SCHEDULED;
    }
    if (appointment.checkedIn) {
      return AppointmentDisplayStatusEnum.CHECKED_IN;
    }
    if (appointment.cancelled) {
      return AppointmentDisplayStatusEnum.CANCELED;
    }
    if (appointment.preregistered) {
      return AppointmentDisplayStatusEnum.PRE_REG_COMPLETED;
    }
    if (appointment.rescheduled) {
      return AppointmentDisplayStatusEnum.RESCHEDULED;
    }
    if (appointmentType != null) {
      var firstDayToPreReg = moment(appointment.time).subtract(appointmentType.getEffectiveFirstDayToPreReg(), 'days');
      var lastDayToPreReg = moment(appointment.time).subtract(appointmentType.getEffectiveLastDayToPreReg(), 'days');
      if (appointmentType.getEffectivePreRegEnabled() && moment().isSameOrAfter(firstDayToPreReg) &&
          moment().isSameOrBefore(lastDayToPreReg)) {
        return AppointmentDisplayStatusEnum.PRE_REG_OPEN;
      } else {
        return AppointmentDisplayStatusEnum.PRE_REG_CLOSED;
      }
    }
    return AppointmentDisplayStatusEnum.SCHEDULED;
  },

  /**
   * Sets details of the specific appointment config to view
   * @method _setAppointmentConfigsToView
   * @param appointmentConfig {Object} config of this specific appointment
   * @private
   */
  _setAppointmentConfigsToView: function(appointmentConfig) {
    var preventBarcode = appointmentConfig.get('configLevels.NORMAL.preRegistration.preventBarcode');
    this.set('preventBarcode', preventBarcode);
    this.set('isAppointmentConfigLoaded', true);
  },

  /**
   * Prints this view.
   * @method _print
   * @param event {jQuery.Event} the event that triggered this call to print.
   * @private
   */
  _print: function(event) {
    event.preventDefault();
    this.$el.find('[data-confirmation-pane]').print();
    return false;
  },

  /**
   * Instantiates a confirmation popup for logout, and logs the user out if it returns true.
   * @method _logout
   * @param event {Object} the event object
   * @private
   */
  _logout: function(event) {
    event.preventDefault();

    var dataViewName = 'confirm signout';
    var logoutCallBack = logoutUtils.logoutWithRedirect;

    if (launcherAppInterface.isAtHospital()) {
      dataViewName = 'confirm ereg signout';
      logoutCallBack = logoutUtils.patientLogoutWithRedirectToEreg;
    }

    this._modalDialogWidget = new ModalDialogWidget({
      dataViewName: dataViewName,
      descriptionKey: 'nav.signOutModal.body',
      yesKey: 'nav.signOutModal.signOut',
      noKey: 'nav.signOutModal.stay'
    });
    this.showModal(this._modalDialogWidget, logoutCallBack);
  },

  /**
   * Performs the logic when clicking on the back button, in this case triggering the browser's back action.
   * @method _back
   * @param event the event that triggered this call.
   * @private
   */
  _back: function(event) {
    if (event && _.isFunction(event.preventDefault)) {
      event.preventDefault();
    }
    history.back();
  },

  /**
   * Mark this appointment as read
   * @method _markAppointmentAsRead
   */
  _markAppointmentAsRead: function() {
    var appointmentMessages = this.getBehavior('appointmentMessages').data.getModels();
    _.each(appointmentMessages, function(appointmentMessage) {
        appointmentMessage.markAsRead();
    });
    userService.messageCountsModel.fetch();
  },

  /**
   * @return {moment.Moment} the moment representation of the date & time for the appointment that this view is displaying.
   * @private
   */
  _getAppointmentDate: function() {
    var appointmentTime = this.getBehavior('appointment').data.get('externalAppointment.time');
    if (appointmentTime) {
      return moment(appointmentTime);
    }
    return null;
  },

  _hasAppointmentLocation: function() {
    var locationBehavior = this.getBehavior('location');
    var locationModel = locationBehavior.data.getModel();
    return locationModel && locationModel.hasAddress();
  },

  _getEndAddress: function() {
    var locationBehavior = this.getBehavior('location');
    var locationModel = locationBehavior.data.getModel();
    if (locationModel && locationModel.hasAddress()) {
      return locationModel.get('address1')
        + ' ' + locationModel.get('city') + ', ' + locationModel.get('state') + ' ' + locationModel.get('zip');
    }
  },

  _getDefaultDestination: function() {
    if (appointmentConfigurationModel.loadedOnce) {
      var mapDefaultEndAddress = appointmentConfigurationModel.get('mapDefaultEndAddress');
      if (mapDefaultEndAddress) {
        return mapDefaultEndAddress;
      } else {
        var latitude = appointmentConfigurationModel.get('mapDefaultLatitude');
        var longitude = appointmentConfigurationModel.get('mapDefaultLongitude');
        return latitude + ',' + longitude;
      }
    }
  }
});
